import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';

@Component({ standalone: false,
  selector: 'vfa-cp-otp-mono-form',
  templateUrl: './otp-mono-form.component.html',
  styleUrls: ['./otp-mono-form.component.scss']
})
export class OtpMonoFormComponent implements OnChanges {
  @Output() validateOtp: EventEmitter<any> = new EventEmitter();
  @Output() askNewOtp: EventEmitter<any> = new EventEmitter();
  @Input() newOtp: any;
  @Input() title: any;
  @Input() subtitle: any;
  @Input() phone: any;
  @Input() waitOtp: any;
  @Input() errorOtp: any;
  @Input() isError: any;
  public inputOTP = "";
  private KEY = 'time';
  private EVENT_KEY = 'exp-otp';
  public counter = '';
  private intervalTimer: any;
  public token = '';
  public showSend = false;
  private regexOTP = new RegExp("[a-zA-Z0-9]");
  @ViewChild("otpInputHtml") otpInputHtml: any;

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnChanges(changes: any) {
    if (changes && changes.newOtp && changes.newOtp.currentValue) {
      this.startMomentCountdown(changes.newOtp.currentValue.expiration_timestamp);
    } if (changes && changes.waitOtp && changes.waitOtp.currentValue) {
      this.waitOtp = changes.waitOtp.currentValue;
    }
    if(changes && changes.isError && changes.isError.currentValue){
      this.isError = changes.isError.currentValue;
      if(this.isError){
        if(this.otpInputHtml) {
          this.inputOTP = "";
          this.otpInputHtml.nativeElement.focus();
        }
      }
    }
  }

  public sendNewOtp() {
    this.askNewOtp.emit();
  }

  public setInput(evt: any) {
    const char = this.checkChar(evt.key);
    if (!char) {
      evt.preventDefault();
      return;
    } else if(evt.key === 'Enter'){
      return;
    } else if (char && evt.target.selectionEnd < evt.target.value.length && this.inputOTP.length === 6 ) {
        evt.preventDefault();
        this.inputOTP = this.inputOTP.slice(0, evt.target.selectionEnd) + char + this.inputOTP.slice(evt.target.selectionEnd+1);
    }
  }

  private checkChar(char: string) {
    if (char && char.length &&  char.match(this.regexOTP)) {
      return char.toLocaleUpperCase();
    } else {
      return null;
    }
  }

  public changeInput(evt: any) {
    if (evt.target.value.length === 6) {
      this.showSend = true;
      this.next();
    } else {
      this.isError = false;

      this.showSend = false;
    }
  }

  private startMomentCountdown(expDate: any) {
    let expirationTime = moment.unix(expDate)
    localStorage.setItem(this.EVENT_KEY, String(expirationTime));
    let currentTime = moment();
    // start countdown
    this.intervalTimer = setInterval(() => {
      currentTime = moment();
      expirationTime = moment(localStorage.getItem(this.EVENT_KEY));
      const remaining = expirationTime.diff(currentTime);
      if (remaining < 0) {
        clearInterval(this.intervalTimer);
        localStorage.removeItem(this.KEY)
        localStorage.removeItem(this.EVENT_KEY)
        this.counter = '';
        this.cdr.detectChanges()
      } else {
        const currentExp = moment.utc(expirationTime.diff(currentTime)).format("mm'ss''");
        this.counter = currentExp;
        localStorage.setItem(this.KEY, currentExp);
        this.cdr.detectChanges()
      }
    }, 1000);
  }

  next() {
    const req = {
      "verification_token": this.inputOTP.toLocaleUpperCase()
    }
    this.validateOtp.emit(req);
  }
}

